import React from 'react';
import {NavLink} from 'react-router-dom';
import {AbMark} from '../brand/AbMark';

/**
 * Shared ambient backdrop + glass card for every auth page: the same glow the
 * player lives in, so login is already inside the product's mood.
 */
export default function AuthShell({children, width = 'max-w-[410px]', bare = false}) {
    return (
        <div
            className="relative flex min-h-screen items-center justify-center bg-ambient-base px-4 py-12 font-display text-white"
            style={{
                backgroundImage:
                    'radial-gradient(55% 90% at 70% 15%, rgba(250,45,72,.18), transparent 60%),' +
                    'radial-gradient(45% 70% at 15% 85%, rgba(255,158,68,.12), transparent 60%)',
            }}
        >
            {bare ? children : (
                <div className={'w-full rounded-3xl border border-white/10 bg-white/5 p-9 shadow-glass backdrop-blur-2xl ' + width}>
                    <div className="flex justify-center">
                        <NavLink to="/" className="text-xl"><AbMark/></NavLink>
                    </div>
                    {children}
                </div>
            )}
            <div className="absolute bottom-5 left-0 right-0 text-center text-[11.5px] text-white/40">
                By continuing you agree to the Terms &amp; Privacy Policy
            </div>
        </div>
    );
}

/** Small shared field primitives so the four auth pages stay identical. */
export const AuthLabel = ({children, htmlFor}) => (
    <label htmlFor={htmlFor} className="mb-1.5 mt-3 block text-[11px] sm:mt-4 font-extrabold uppercase tracking-[0.07em] text-white/40">
        {children}
    </label>
);

export const AuthInput = (props) => (
    <input
        {...props}
        className="w-full rounded-xl border border-white/10 bg-white/[0.06] px-3.5 py-2.5 text-sm sm:py-3 text-white placeholder-white/30 outline-none focus:border-apple-red/60"
    />
);

export const AuthButton = ({children, ...props}) => (
    <button
        {...props}
        className="mt-4 w-full rounded-xl bg-apple-red py-2.5 text-[14.5px] sm:mt-5 sm:py-3 font-extrabold text-white shadow-[0_12px_30px_rgba(250,45,72,0.30)] transition hover:brightness-110 disabled:opacity-50"
    >
        {children}
    </button>
);

export const AuthError = ({error}) => (
    error ? <p className="mt-4 rounded-lg bg-apple-red/15 px-3 py-2 text-[12.5px] font-medium text-[#ff97a5]">{error}</p> : null
);
